import SimpleCrypto from 'simple-crypto-js'

import {
  pabxPermissions,
  relatoriosPABXPermissions,
  monitorRamaisPermissions,
  callCenterPermissions,
  satisfactionResearchPermissions,
  usersModulePermissions,
} from '@/utils/arraysPermissions'

export const appBarMixins = {
  data: () => ({
    numberOfPermissions: 0,
    permissaoPabx: false,
    permissaoRelatorioPabx: false,
    permissaoMonitorRamais: false,
    permissaoCallCenter: false,
    permissaoPesquisaSatisfacao: false,
    permissaoUsuarios: false,
    showSkeleton: false,
  }),

  async created() {
    this.showSkeleton = true

    const simpleCrypto = new SimpleCrypto(process.env.VUE_APP_CRYPTO)
    const arrayPermissionsJSON = localStorage.getItem('pcm_permissions')
    const arrayPermissions = simpleCrypto.decrypt(arrayPermissionsJSON)

    arrayPermissions.forEach(permissionLocalStorage => {
      if (pabxPermissions.includes(permissionLocalStorage) && !this.permissaoPabx) {
        this.numberOfPermissions += 1
        this.permissaoPabx = true
      }
      if (relatoriosPABXPermissions.includes(permissionLocalStorage) && !this.permissaoRelatorioPabx) {
        this.numberOfPermissions += 1
        this.permissaoRelatorioPabx = true
      }
      if (monitorRamaisPermissions.includes(permissionLocalStorage) && !this.permissaoMonitorRamais) {
        this.numberOfPermissions += 1
        this.permissaoMonitorRamais = true
      }
      if (callCenterPermissions.includes(permissionLocalStorage) && !this.permissaoCallCenter) {
        this.numberOfPermissions += 1
        this.permissaoCallCenter = true
      }
      if (satisfactionResearchPermissions.includes(permissionLocalStorage) && !this.permissaoPesquisaSatisfacao) {
        this.numberOfPermissions += 1
        this.permissaoPesquisaSatisfacao = true
      }
      if (usersModulePermissions.includes(permissionLocalStorage) && !this.permissaoUsuarios) {
        this.numberOfPermissions += 1
        this.permissaoUsuarios = true
      }
    })

    this.showSkeleton = false
  },

  methods: {
    goToPabx(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const pabxRoute = this.$router.resolve({ name: 'pabx' })
        window.open(pabxRoute.href, '_blank')
      } else {
        this.$router.push({ name: 'pabx' })
      }
    },

    goToRelatoriosPabx(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const relatoriosPabxRoute = this.$router.resolve({ name: 'relatorios_pabx' })
        window.open(relatoriosPabxRoute.href, '_blank')
      } else {
        this.$router.push({ name: 'relatorios_pabx' })
      }
    },

    goToMonitorOnly(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const monitorRamaisRoute = this.$router.resolve({ name: 'onlyMonitor' })
        window.open(monitorRamaisRoute.href, '_blank')
      } else {
        this.$router.push({ name: 'onlyMonitor' })
      }
    },

    goToCallCenter(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const callCenterRoute = this.$router.resolve({ name: 'callcenter' })
        window.open(callCenterRoute.href, '_blank')
      } else {
        this.$router.push({ name: 'callcenter' })
      }
    },

    goToSatisfactionResearch(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const satisfactionResearchRoute = this.$router.resolve({ name: 'satisfaction_research' })
        window.open(satisfactionResearchRoute.href, '_blank')
      } else {
        this.$router.push({ name: 'satisfaction_research' })
      }
    },

    goToAccessControl(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const accessControlRoute = this.$router.resolve({ name: 'AccessControl' })
        window.open(accessControlRoute.href, '_blank')
      } else {
        this.$router.push({ name: 'AccessControl' })
      }
    },

    backToLobby(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const selectModuleRoute = this.$router.resolve({ name: 'select_module' })
        window.open(selectModuleRoute.href, '_blank')
      } else {
        this.$router.push({ name: 'select_module' })
      }
    },
  },
}
